/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Ai_Model_HelpInputs */

const en_ai_model_help = /** @type {(inputs: Ai_Model_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empty uses ${i?.model}.`)
};

const de_ai_model_help = /** @type {(inputs: Ai_Model_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leer bedeutet ${i?.model}.`)
};

/**
* | output |
* | --- |
* | "Empty uses {model}." |
*
* @param {Ai_Model_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_model_help = /** @type {((inputs: Ai_Model_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Model_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_model_help(inputs)
	return en_ai_model_help(inputs)
});